import React from 'react';
import "./Footer.styles.css";

const Footer = () => {
    return (
        <footer className={'footer'}>
            <p style={{color: 'grey', margin: 0}}>Restaurant Management System. App developed by Ernest Bieś 2021 &copy; All rights reserved.</p>
        </footer>
    );
}

export default Footer;
